import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { TeamMemberExcelFailure } from '../../types/entity.types';
import {
  DownloadTeamExcelRequest,
  UploadTeamExcelRequest,
  ViewTeamLeaderboardRequest,
  ViewTeamsForProgrammeRequest
} from './programme-teams.types';

import {
  requestDownloadTeamExcel,
  requestUploadTeamExcel,
  requestViewTeamLeaderboard,
  requestViewTeamsForProgramme
} from './programme-teams.actions';

export const useProgrammeTeamsApi = () => {
  const dispatch = useDispatch();

  const viewTeamsForProgramme = useCallback(
    (requestData: ViewTeamsForProgrammeRequest) => {
      dispatch(requestViewTeamsForProgramme({ requestData }));
    },
    [dispatch]
  );

  const downloadTeamExcel = useCallback(
    (requestData: DownloadTeamExcelRequest) => {
      dispatch(requestDownloadTeamExcel({ requestData }));
    },
    [dispatch]
  );

  const uploadTeamExcel = useCallback(
    (requestData: UploadTeamExcelRequest, onError?: (failures: TeamMemberExcelFailure[]) => void) => {
      dispatch(requestUploadTeamExcel({ requestData, onError }));
    },
    [dispatch]
  );

  const viewTeamLeaderboard = useCallback(
    (requestData: ViewTeamLeaderboardRequest) => {
      dispatch(requestViewTeamLeaderboard({ requestData }));
    },
    [dispatch]
  );

  return { viewTeamsForProgramme, downloadTeamExcel, uploadTeamExcel, viewTeamLeaderboard };
};
